import React, { Component } from 'react';
import ReactTableWrapper from 'Common/ReactTableWrapper';
import { Checkbox } from 'semantic-ui-react';

import { TableNamesEnum } from 'Common/Constants/Enumeration/TableEnum';

export class FamilyMatchUtilityStudentTable extends Component {
  static defaultProps = {
    loading: false,
  };

  handleCheckedItem = (checkedValue, row) => {
    this.props.checkStudentGrid(checkedValue, row);
    if (checkedValue === true) {
      this.props.onSelect(row.IdSeed);
    } else {
      this.props.onRemove(row.IdSeed);
    }
  };

  columns = [
    {
      Header: 'Select',
      accessor: 'Selected',
      maxWidth: 45,
      width: 45,
      filterable: false,
      Cell: ({ original }) => {
        if (original) {
          return (
            <div style={{ textAlign: 'center' }}>
              <Checkbox
                checked={original.Selected ? true : false}
                onChange={() => {
                  this.handleCheckedItem(!original.Selected, original);
                }}
              />
            </div>
          );
        }
      },
    },
    {
      Header: 'Student Id',
      accessor: 'Id',
      sortable: true,
      width: 125,
      show: true,
      visibility: true,
    },
    {
      Header: 'Student First Name',
      accessor: 'FirstName',
      sortable: true,
      width: 125,
      show: true,
      visibility: true,
    },
    {
      Header: 'Student Last Name',
      accessor: 'LastName',
      sortable: true,
      width: 125,
      show: true,
      visibility: true,
    },
    {
      Header: 'Address 1',
      accessor: 'Address1',
      sortable: true,
      width: 100,
      show: true,
      visibility: true,
    },
    {
      Header: 'Address 2',
      accessor: 'Address2',
      sortable: true,
      width: 80,
      show: true,
      visibility: true,
    },
    {
      Header: 'City',
      accessor: 'City',
      sortable: true,
      width: 60,
      show: true,
      visibility: true,
    },
    {
      Header: 'State',
      accessor: 'State',
      sortable: true,
      width: 45,
      show: true,
      visibility: true,
    },
    {
      Header: 'Zip Code',
      accessor: 'ZipCode',
      sortable: true,
      width: 60,
      show: true,
      visibility: true,
    },
    {
      Header: 'Parent First Name',
      accessor: 'HHFirstName',
      sortable: true,
      show: true,
      visibility: true,
    },
    {
      Header: 'Parent Last Name',
      accessor: 'HHLastName',
      sortable: true,
      show: true,
      visibility: true,
    },
    {
      Header: 'Status',
      accessor: 'Status',
      sortable: true,
      show: true,
      visibility: true,
    },
    {
      Header: 'Eligibility Type',
      accessor: 'EligibilityType',
      sortable: true,
      show: true,
      visibility: true,
    },
    {
      Header: 'DC',
      accessor: 'DirectCertified',
      sortable: true,
      filterable: false,
      Cell: ({ original }) => {
        if (original) {
          return (
            <div style={{ textAlign: 'center' }}>
              <Checkbox checked={original.DirectCertified} disabled={true} />
            </div>
          );
        }
      },
      show: true,
      visibility: true,
    },
  ];

  render() {
    return (
      <ReactTableWrapper
        className={'family-match-utility-student-grid'}
        saveState={{
          tableName: TableNamesEnum.FAMILY_MATCH_UTILITY_STUDENTS_TABLE,
        }}
        loading={this.props.loading}
        data={this.props.studentData}
        filterable={true}
        columns={this.columns}
        noDataText="No Students Found"
        defaultPageSize={10}
        minRows={5}
        resizable={true}
        showMenu={true}
        resetPageOnDataChange={false}
        showHideColumn={true}
      />
    );
  }
}



// WEBPACK FOOTER //
// ./src/pages/familymatchutility/components/FamilyMatchUtilityStudentTable.js